import React, { useState, useEffect } from "react";
import Navbar from "../components/Navbar";
import { Link, useNavigate } from "react-router-dom";
import { Container, Grid, Stack, Typography } from "@mui/material";

import { myRequests } from "../apis";
import _ from "lodash";
import FeedRequestCard from "./Feeds/components/FeedRequestCard";
import SelectedRequest from "./Feeds/components/SelectedRequest";

const MyRequests = () => {
  const user = JSON.parse(localStorage.getItem("user-info"));
  const userID = user?.googleId ? user.googleId : user._id;

  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [selectedRequest, setSelectedRequest] = useState(null);

  useEffect(() => {
    const fetchData = async () => {
      const response = await myRequests(userID);
      setData(response.data.requests);
    };
    fetchData();
  }, []);

  useEffect(() => {
    if (data.length) {
      setLoading(false);
    }
  }, [data]);

  const RequestClickhandler = (id) => {
    const filteredResult = data.filter((item) => item._id == id);
    setSelectedRequest(filteredResult[0]);
  };

  if (loading) {
    return (
      <>
        <Navbar />
      </>
    );
  } else {
    return (
      <>
        <Navbar />
        <div style={{ width: "90%", margin: "auto" }}>
          <Grid container spacing={4}>
            <Grid item sm={7}>
              <Container>
                <Typography variant="h5" className="mb-16">
                  All Requests
                </Typography>
                <div
                  style={{ border: "1px solid #EEEBEF", borderRadius: "6px" }}
                  className="mb-16"
                >
                  <Stack spacing={2}>
                    {data &&
                      data.map((request) => (
                        <FeedRequestCard
                          title={request.title}
                          location={request.address}
                          fromDate={request.fromDate}
                          urgent={request.urgent}
                          details={request.details}
                          id={request._id}
                          clickHandler={RequestClickhandler}
                        />
                      ))}
                  </Stack>
                </div>
              </Container>
            </Grid>
            <Grid item sm={5}>
              {selectedRequest != null ? (
                <SelectedRequest currentRequest={selectedRequest} viewOnly />
              ) : null}
            </Grid>
          </Grid>
        </div>
      </>
    );
  }
};

export default MyRequests;
